import styled from '@emotion/styled';
import { GroupedVirtuoso } from 'react-virtuoso';

// GroupedVirtuoso relies on z-indexes. Giving the container `z-index: 0` (and
// `position: relative`, which it already comes with) makes it the root of a new
// stacking context, so its z-indexes can't conflict with anything else.
export const VirtualizedGroupList = styled(GroupedVirtuoso)({
  zIndex: 0,
});
